import React from 'react';
import ReactDOM from 'react-dom/client';
import { applyThemeToDocument, resolveInitialTheme } from './config/themes';
import './index.css';
import App from './App';

applyThemeToDocument(resolveInitialTheme());

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
